import React, { useState, useEffect } from "react";
import { useParams, NavLink, useHistory } from "react-router-dom";

import MakeAPICall from "../../apiCalls/common";

import {
  getDoctorBookingsApiRoute,
  editDoctorProfileApiRoute
} from "../../apiRoutes";

import appRoutes from "../../routes/appRoutes";

import {
  mapDoctorDetailsIncomingData,
  mapDoctorProfileSubmitData
} from "./doctorDetailsDataMapping";

import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import DoctorProfileForm from "../../containers/DoctorForms/doctorProfileForm";
import { STATE_LIST } from "../../constants/constants";

const DoctorNewApplicationDetails = props => {
  let history = useHistory();
  let { id } = useParams();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams1, setApiCallParams1] = useState(null);
  const [data, setData] = useState(null);
  const [showSuccModal, setShowSuccModal] = useState(false);
  const [succModalText, setSuccModalText] = useState("");
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");

  // get doctor details
  const getDetails = async () => {
    let params = {
      skip: 10,
      limit: 0,
      doctorId: id
    };

    await setApiCallParams1({
      reqType: "GET",
      reqUrl: getDoctorBookingsApiRoute,
      params: params,
      successCallback: async res => {
        let data = await mapDoctorDetailsIncomingData(
          res.data.data.doctorDetails
        );

        setData(data);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFormSubmit = values => {
    setIsProcessing(true);

    let formData = mapDoctorProfileSubmitData(values, data._id);

    setApiCallParams1({
      reqType: "PUT",
      reqUrl: editDoctorProfileApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        setSuccModalText("Doctor's Details Saved Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
       // setErrModalText(err.message);
        //setShowErrModal(true);
      }
    });
  };

  const onCancelForm = () => {
    history.push(appRoutes.doctorNewApplications, {
      currPageNo:
        props.location.state && props.location.state.currPageNo
          ? props.location.state.currPageNo
          : null
    });
  };

  return (
    <div className="view-ticket-container doctor-profile-page-container">
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
          setErrModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showSuccModal}
        cancelEvent={() => {
          setShowSuccModal(false);
          setSuccModalText("");
          history.push(appRoutes.doctorNewApplications, {
            currPageNo:
              props.location.state && props.location.state.currPageNo
                ? props.location.state.currPageNo
                : null
          });
        }}
        modalBodyContent={<p className="text-center mb-0">{succModalText}</p>}
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <NavLink
          to={{
            pathname: appRoutes.doctorNewApplications,
            state: {
              currPageNo:
                props.location.state && props.location.state.currPageNo
                  ? props.location.state.currPageNo
                  : null
            }
          }}
          className="details-back-link"
          href="#"
        >
          <i className="fas fa-arrow-left"></i>{" "}
          <span className="ml-1 back-btn-text"> Back to New Applications</span>
        </NavLink>
        <h3 className="mt-4">New Application</h3>

        <br />
        <DoctorProfileForm
          onSubmitForm={onFormSubmit}
          onCancelForm={onCancelForm}
          data={data}
          states={STATE_LIST}
        />
        <br />
        <br />
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams1} />
      {/*<MakeAPICall apiParam={apiCallParams2} />*/}
    </div>
  );
};

export default DoctorNewApplicationDetails;
